require('./partials/http-request');
require('./partials/partner');
require('./partials/mitra');
require('./partials/employee');
require('./partials/maps');
require('./partials/province');